import React from 'react';
import columns from './columns';
import ExportsFilters from './exports-filters';
import messages from './messages';
import Breadcrumbs from 'components/Common/Breadcrumb';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';

const ExportsPage = () => {
  const {t} = useTranslation();
  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.pageTitle())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {title: t(...messages.exports()), path: '#'},
          ]}
        />
        <Table
          columns={columns}
          url="exports"
          name="exports"
          filtersComponent={ExportsFilters}
        />
      </Container>
    </div>
  );
};

export default ExportsPage;
